// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/images/iphone-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Colors
 */
/**
 * Paddings, margins.
 */
/**
 *  Images
 */
/**
 * Fonts.
 */
/**
 * Mixins.
 */
.animate {
  -webkit-transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);
}
.iphone-wrapper {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: 200px;
  background-repeat: no-repeat;
  background-position: top;
  min-height: 420px;
  padding-top: 48px;
}
.content__create-topleft input {
  padding: 10px;
  margin-bottom: 10px;
}
.content__create-topleft > .tabs a {
  background-color: #a5a3a6;
  color: #000000;
  display: inline-block;
  padding: 10px;
  text-align: center;
}
.content__create-topleft > .tabs a.active {
  background-color: #4ca92f;
  color: #ffffff;
}
.content__create-topleft > .tabs a:hover,
.content__create-topleft > .tabs a:focus {
  text-decoration: none;
}
.content__create-topleft > .tabContent {
  margin-bottom: 10px;
}
.content__create-topleft .controls {
  text-align: center;
}
.content__create-topleft .questions,
.content__create-topleft .pictures {
  margin: 10px 0;
}
.content__create-topleft .questions.pictures,
.content__create-topleft .pictures.pictures {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-flow: row wrap;
          flex-flow: row wrap;
  background-color: #ffffff;
}
.content__create-topleft .questions .questions__question,
.content__create-topleft .pictures .questions__question,
.content__create-topleft .questions .pictures__picture,
.content__create-topleft .pictures .pictures__picture {
  text-align: center;
}
.content__create-topleft .questions .questions__question.questions__question,
.content__create-topleft .pictures .questions__question.questions__question,
.content__create-topleft .questions .pictures__picture.questions__question,
.content__create-topleft .pictures .pictures__picture.questions__question {
  padding: 10px;
}
.content__create-topleft .questions .questions__question.pictures__picture,
.content__create-topleft .pictures .questions__question.pictures__picture,
.content__create-topleft .questions .pictures__picture.pictures__picture,
.content__create-topleft .pictures .pictures__picture.pictures__picture {
  padding: 5px;
  width: 25%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}
.content__create-topleft .questions .questions__question.pictures__picture img,
.content__create-topleft .pictures .questions__question.pictures__picture img,
.content__create-topleft .questions .pictures__picture.pictures__picture img,
.content__create-topleft .pictures .pictures__picture.pictures__picture img {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
}
.content__create-topleft .questions .questions__question.active,
.content__create-topleft .pictures .questions__question.active,
.content__create-topleft .questions .pictures__picture.active,
.content__create-topleft .pictures .pictures__picture.active {
  background-color: #4ca92f;
  border-color: #ffffff;
  color: #ffffff;
}
.content__create-topleft .questions .questions__question:hover,
.content__create-topleft .pictures .questions__question:hover,
.content__create-topleft .questions .pictures__picture:hover,
.content__create-topleft .pictures .pictures__picture:hover {
  cursor: pointer;
}
.content__create-topright {
  text-align: center;
}
.content__create-topright h4 {
  margin-top: 1em;
}
.content__create-topright .preview {
  background-color: #ffffff;
  margin: auto;
  min-height: 312px;
  max-width: 177px;
  padding: 8px 10px 0;
}
.content__create-topright .preview img {
  max-width: 90%;
}
.content__create-topright .preview-logo {
  height: 20px;
  width: auto;
}
.content__create-topright .preview-question {
  margin: 20px 0;
}
.content__create-topright .preview-input {
  margin: 20px 0;
  border: 1px solid #aaa;
  border-radius: 0.5em;
  padding: 5px;
  text-align: right;
}
.content__create-topright .preview-input img {
  max-width: 40px;
}
.content__create-topright .preview-vote img {
  max-width: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/feature/create/create.less","webpack://./src/less/variables.less"],"names":[],"mappings":"AAAA;;EAEE;AACF;;EAEE;AACF;;EAEE;AACF;;EAEE;AACF;;EAEE;ACsBF;EACE,4DAAA;EAAA,oDAAA;ADpBF;AAfA;EACE,6DAAA;EACA,sBAAA;EACA,4BAAA;EACA,wBAAA;EACA,iBAAA;EACA,iBAAA;AAiBF;AAbE;EACE,aAAA;EACA,mBAAA;AAeJ;AAZE;EAEI,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;AAaN;AAXM;EACE,yBAAA;EACA,cAAA;AAaR;AAVM;;EACE,qBAAA;AAaR;AARE;EACE,mBAAA;AAUJ;AApCA;EA8BI,kBAAA;AASJ;AAvCA;;EAkCI,cAAA;AASJ;AAPI;;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,8BAAA;EAAA,6BAAA;MAAA,uBAAA;UAAA,mBAAA;EACA,yBAAA;AAUN;AAlDA;;;;EA8DM,kBAAA;AANN;AAZM;;;;EACE,aAAA;AAiBR;AAdM;;;;EACE,YAAA;EACA,UAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;AAmBR;AAvBM;;;;EAOI,WAAA;EACA,YAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;AAsBV;AAhBM;;;;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAqBR;AAlBM;;;;EACE,eAAA;AAuBR;AAjBA;EACE,kBAAA;AAmBF;AApBA;EAII,eAAA;AAmBJ;AAvBA;EAQI,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAkBJ;AA9BA;EAeM,cAAA;AAkBN;AAjCA;EAoBI,YAAA;EACA,WAAA;AAgBJ;AArCA;EAyBI,cAAA;AAeJ;AAxCA;EA6BI,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;EACA,iBAAA;AAcJ;AA/CA;EAmCM,eAAA;AAeN;AAlDA;EAyCM,eAAA;AAYN","sourcesContent":["@import '../../less/variables';\n\n.iphone-wrapper {\n  background: url(\"../../../public/assets/images/iphone-bg.png\") no-repeat;\n  background-size: 200px;\n  background-repeat: no-repeat;\n  background-position: top;\n  min-height: 420px;\n  padding-top: 48px;\n}\n\n.content__create-topleft {\n  & input {\n    padding: @padding-btn;\n    margin-bottom: @margin-base;\n  }\n\n  & > .tabs {\n    a {\n      background-color: @gray-dark;\n      color: @black;\n      display: inline-block;\n      padding: @padding-btn;\n      text-align: center;\n\n      &.active {\n        background-color: @green;\n        color: @white;\n      }\n\n      &:hover, &:focus {\n        text-decoration: none;\n      }\n    }\n  }\n\n  & > .tabContent {\n    margin-bottom: @margin-base;\n  }\n\n  .controls {\n    text-align: center;\n  }\n\n  .questions, .pictures {\n    margin: @margin-base 0;\n\n    &.pictures {\n      display: flex;\n      justify-content: center;\n      flex-flow: row wrap;\n      background-color: @white;\n    }\n\n    .questions__question, .pictures__picture {\n      &.questions__question {\n        padding: @padding-content * 2;\n      }\n\n      &.pictures__picture {\n        padding: @padding-content;\n        width: 25%;\n        display: flex;\n        flex-direction: column;\n\n        img {\n          width: 100%;\n          height: 100%;\n          display: flex;\n          flex: 1;\n        }\n      }\n\n      text-align: center;\n\n      &.active {\n        background-color: @green;\n        border-color: @white;\n        color: @white;\n      }\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.content__create-topright {\n  text-align: center;\n\n  h4 {\n    margin-top: 1em;\n  }\n\n  .preview {\n    background-color: @white;\n    margin: auto;\n    min-height: 312px;\n    max-width: 177px;\n    padding: 8px 10px 0;\n\n    img {\n      max-width: 90%;\n    }\n  }\n\n  .preview-logo {\n    height: 20px;\n    width: auto;\n  }\n\n  .preview-question {\n    margin: 20px 0;\n  }\n\n  .preview-input {\n    margin: 20px 0;\n    border: 1px solid #aaa;\n    border-radius: 0.5em;\n    padding: 5px;\n    text-align: right;\n    img {\n      max-width: 40px;\n    }\n  }\n\n  .preview-vote {\n    img {\n      max-width: 60px;\n    }\n  }\n}\n","/**\n * Colors\n */\n@black: rgb(0, 0, 0);\n@blue: rgb(7, 191, 234);\n@cream: rgb(250, 250, 250);\n@gray-dark: rgb(165, 163, 166);\n@gray: rgb(230, 230, 230);\n@gray-outline: rgb(217, 217, 217);\n@green-dark: rgb(63, 136, 41);\n@green: rgb(76, 169, 47);\n@white: rgb(255, 255, 255);\n@error: rgb(255, 0, 0);\n\n/**\n * Paddings, margins.\n */\n@padding-content: 5px;\n@padding-btn: 10px;\n@padding-navi-link: 10px;\n@margin-btn: 10px;\n@margin-base: 10px;\n\n/**\n *  Images\n */\n@img-size-upload: 150px;\n\n/**\n * Fonts.\n */\n@font-size-base: 1.6em;\n\n/**\n * Mixins.\n */\n.animate {\n  transition: all 0.35s cubic-bezier(0.35, 0, 0.25, 1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
